import { z } from "zod";

export const countGraphemes = (str: string): number => {
  const Seg: any = (Intl as any).Segmenter;
  if (typeof Seg === "function") {
    const seg = new Seg("ja-JP", { granularity: "grapheme" });
    return Array.from(seg.segment(str)).length;
  }
  // Fallback: approximate by code points (not perfect for all graphemes)
  return Array.from(str).length;
};
export const zGraphemeString = (opt?: { min?: number; max?: number }) => {
  let s: z.ZodType<string> = z.string();
  if (opt?.min != null) {
    s = s.refine((v) => countGraphemes(v) >= opt.min!, {
      message: `${opt.min}文字以上で入力してください`,
    });
  }
  if (opt?.max != null) {
    s = s.refine((v) => countGraphemes(v) <= opt.max!, {
      message: `${opt.max}文字以内で入力してください`,
    });
  }
  return s;
};
